shadow$provide[270] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Vertex:{enumerable:true, get:function() {
  return Vertex;
}}});
var require$_DOT__SLASH_transform_DOT_js = require("./transform.js");
class Vertex extends require$_DOT__SLASH_transform_DOT_js.Transform {
  static initClass() {
    this.traits = ["node", "include", "vertex", "bind"];
  }
  make() {
    return this._helpers.bind.make([{to:"include.shader", trait:"shader", optional:true},]);
  }
  unmake() {
    return this._helpers.bind.unmake();
  }
  change(changed, touched, _init) {
    if (touched["include"]) {
      return this.rebuild();
    }
  }
  vertex(shader, pass) {
    if (this.bind.shader != null) {
      if (pass === this.props.pass) {
        shader.pipe(this.bind.shader.shaderBind());
      }
    }
    return super.vertex(shader, pass);
  }
}
Vertex.initClass();

};